/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Standards_Preset_Saved_ToastInputs */



/**
* | output |
* | --- |
* | "Standards preset \"{name}\" saved" |
*
* @param {Standards_Preset_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_saved_toast = /** @type {((inputs: Standards_Preset_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
	return /** @type {LocalizedString} */ (`Standards preset "${i?.name}" saved`)
});